export default defineNuxtPlugin(() => {
  const gtmEvent = (
    clickPrice: string,
    storeId: number,
    price: number,
    oldPrice = ''
  ) => {
    let gtmData: { [key: string]: string | number } = {};
    const obj: { [key: string]: string | number } = {};
    const dataLayer = window.dataLayer || [];
    try {
      if (dataLayer?.[0]?.event) {
        for (const attrname in dataLayer[0])
          obj[attrname] = dataLayer[0][attrname];
        gtmData = obj;
      }
    } catch (e) {
      gtmData = {};
    }
    gtmData.event = 'clickout';
    gtmData.clickoutPrice = clickPrice;
    gtmData.storeId = storeId;
    gtmData.price = price;
    gtmData.oldPrice = oldPrice;
    dataLayer.push(gtmData);
  };

  const gtmModelEvent = (prodId: string, totalValue: string) => {
    if (prodId) {
      try {
        const dataLayer = window.dataLayer || [];
        dataLayer.push({
          ecomm_prodid: prodId,
          ecomm_pagetype: 'product',
          ...(totalValue ? { ecomm_totalvalue: totalValue } : {}),
        });
      } catch (e) {}
    }
  };

  const gtmOfferEvent = (prodId: number, totalValue: number) => {
    if (prodId) {
      try {
        const dataLayer = window.dataLayer || [];
        dataLayer.push({
          ecomm_prodid: prodId,
          ecomm_pagetype: 'cart',
          ...(totalValue ? { ecomm_totalvalue: totalValue } : {}),
        });
      } catch (e) {}
    }
  };

  const gaEvent = (category: string, label: string, value: string) => {
    try {
      // @ts-ignore
      gtag('event', 'click', {
        event_category: category,
        event_label: label,
        value,
      });
    } catch (e) {}
  };

  const gtagEvent = (value: string) => {
    try {
      // @ts-ignore
      gtag('event', 'out', {
        event_category: 'click',
        value,
      });
    } catch (e) {}
  };

  const ymGoalEvent = (
    price: string,
    proved_merchant: boolean,
    with_rating: boolean,
    block: string,
    slot: number,
    monitoring: string
  ) => {
    try {
      const goalParams = {
        order_price: price,
        currency: 'RUB',
        proved_merchant,
        with_rating,
        block,
        slot,
        ...(monitoring ? { label: monitoring } : {}),
      };
      // @ts-ignore
      ym(17022754, 'reachGoal', 'click2shop', goalParams);
    } catch (e) {}
  };

  const ymClickSortEvent = (sort: string) => {
    try {
      // @ts-ignore
      ym(17022754, 'reachGoal', 'click2sort', { sort });
    } catch (e) {}
  };
  const ymClickCategEvent = (id: string) => {
    try {
      // @ts-ignore
      ym(17022754, 'reachGoal', 'click2categ', { id });
    } catch (e) {}
  };
  const ymClickLogoEvent = (shopId: string) => {
    try {
      // @ts-ignore
      ym(17022754, 'reachGoal', 'clicklogo', { id: shopId });
    } catch (e) {}
  };

  const ymGoalEventPromo = (tag: string, modelId: string) => {
    try {
      const goalParams = {
        id: modelId,
      };
      // @ts-ignore
      ym(17022754, 'reachGoal', tag, goalParams);
    } catch (e) {}
  };

  const ymCpcEvent = () => {
    try {
      // @ts-ignore
      ym(17022754, 'reachGoal', 'CLICKOUT');
    } catch (e) {}
  };

  const ymAnyEvent = (type: string, event: string) => {
    try {
      // @ts-ignore
      ym(17022754, type, event);
    } catch (e) {}
  };
  const ymAnyEventWithParam = (type: string, event: string, param: any) => {
    try {
      // @ts-ignore
      ym(17022754, type, event, param);
    } catch (e) {}
  };

  const ymEcommerceEvent = (type: string, data: any) => {
    try {
      const dataLayer = window.dataLayer || [];
      dataLayer.push({
        ecommerce: {
          currencyCode: 'RUB',
          [type]: {
            products: [
              {
                id: data.id,
                name: data.name,
                price: data.price,
                brand: data.brand,
                category: data.category,
                [type === 'add' ? 'quantity' : 'variant']: data.other,
              },
            ],
          },
        },
      });
    } catch (e) {}
  };

  const DSPCounterEvent = (sz: string, value: any) => {
    try {
      if (window && 'DSPCounter' in window) {
        window.DSPCounter('send', {
          sz,
          sid: 224071,
          custom: value,
        });
      }
    } catch (e) {}
  };

  const tmrSaleEvent = (
    price: number | string,
    id: number | undefined | null
  ) => {
    try {
      if (price) {
        // @ts-ignore
        _tmr.push({
          type: 'reachGoal',
          id: 3499389,
          goal: 'clickout',
          value: price,
          params: { product_id: id },
        });
      }
    } catch (e) {}
  };

  return {
    provide: {
      gtmEvent,
      gtmModelEvent,
      gtmOfferEvent,
      gaEvent,
      gtagEvent,
      ymGoalEvent,
      ymClickSortEvent,
      ymClickCategEvent,
      ymClickLogoEvent,
      ymGoalEventPromo,
      ymCpcEvent,
      DSPCounterEvent,
      ymEcommerceEvent,
      ymAnyEvent,
      ymAnyEventWithParam,
      tmrSaleEvent,
    },
  };
});
